"use client";
import SvgErrorFilled from "./error-filled.svg.js";
import SvgErrorOutlined from "./error-outlined.svg.js";
import SvgErrorRound from "./error-round.svg.js";
import SvgErrorSharp from "./error-sharp.svg.js";
import SvgHelpFilled from "./help-filled.svg.js";
import SvgHelpOutlined from "./help-outlined.svg.js";
import SvgHelpRound from "./help-round.svg.js";
import SvgHelpSharp from "./help-sharp.svg.js";
import SvgInfoFilled from "./info-filled.svg.js";
import SvgInfoOutlined from "./info-outlined.svg.js";
import SvgInfoRound from "./info-round.svg.js";
import SvgInfoSharp from "./info-sharp.svg.js";
import SvgSuccessFilled from "./success-filled.svg.js";
import SvgSuccessOutlined from "./success-outlined.svg.js";
import SvgSuccessRound from "./success-round.svg.js";
import SvgSuccessSharp from "./success-sharp.svg.js";
import SvgWarningFilled from "./warning-filled.svg.js";
import SvgWarningOutlined from "./warning-outlined.svg.js";
import SvgWarningRound from "./warning-round.svg.js";
import SvgWarningSharp from "./warning-sharp.svg.js";
const error = {
  filled: SvgErrorFilled,
  outlined: SvgErrorOutlined,
  round: SvgErrorRound,
  sharp: SvgErrorSharp
};
const help = {
  filled: SvgHelpFilled,
  outlined: SvgHelpOutlined,
  round: SvgHelpRound,
  sharp: SvgHelpSharp
};
const info = {
  filled: SvgInfoFilled,
  outlined: SvgInfoOutlined,
  round: SvgInfoRound,
  sharp: SvgInfoSharp
};
const success = {
  filled: SvgSuccessFilled,
  outlined: SvgSuccessOutlined,
  round: SvgSuccessRound,
  sharp: SvgSuccessSharp
};
const warning = {
  filled: SvgWarningFilled,
  outlined: SvgWarningOutlined,
  round: SvgWarningRound,
  sharp: SvgWarningSharp
};
export {
  error,
  help,
  info,
  success,
  warning
};
